import { render, staticRenderFns } from "./coupon.vue?vue&type=template&id=48067348&"
import script from "./coupon.vue?vue&type=script&lang=js&"
export * from "./coupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48067348')) {
      api.createRecord('48067348', component.options)
    } else {
      api.reload('48067348', component.options)
    }
    module.hot.accept("./coupon.vue?vue&type=template&id=48067348&", function () {
      api.rerender('48067348', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iotSetting/coupon/coupon.vue"
export default component.exports